/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AdminOrderType = {
    OrderTypeCustomer: 'customer_order',
    OrderTypeMarketplace: 'marketplace_order',
    OrderTypeSelfSale: 'self_sale'
} as const;
export type AdminOrderType = typeof AdminOrderType[keyof typeof AdminOrderType];


export function instanceOfAdminOrderType(value: any): boolean {
    for (const key in AdminOrderType) {
        if (Object.prototype.hasOwnProperty.call(AdminOrderType, key)) {
            if (AdminOrderType[key as keyof typeof AdminOrderType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AdminOrderTypeFromJSON(json: any): AdminOrderType {
    return AdminOrderTypeFromJSONTyped(json, false);
}

export function AdminOrderTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminOrderType {
    return json as AdminOrderType;
}

export function AdminOrderTypeToJSON(value?: AdminOrderType | null): any {
    return value as any;
}

export function AdminOrderTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): AdminOrderType {
    return value as AdminOrderType;
}

